import { render, staticRenderFns } from "./TabUsersExternal.vue?vue&type=template&id=110949a2"
import script from "./TabUsersExternal.vue?vue&type=script&lang=ts"
export * from "./TabUsersExternal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports